document.addEventListener("DOMContentLoaded", () => {
    const menuDrawer = document.getElementById("t4s-menu-drawer");
    const overlay = document.querySelector(".t4s-close-overlay");

    if (!menuDrawer || !overlay){
        return;
    } 

    const originalZIndex = window.getComputedStyle(overlay).zIndex;

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.attributeName === "aria-hidden") {
                const isHidden = menuDrawer.getAttribute("aria-hidden") === "true";
                if (isHidden) {
                    setTimeout(() => {
                        //overlay.style.zIndex = originalZIndex;
                        overlay.style.removeProperty('visibility');
                    }, 500);
                } else {
                    //overlay.style.zIndex = "458";
                    overlay.style.visibility = "hidden";
                }
            }
        });
    });

    observer.observe(menuDrawer, { attributes: true });


    $(document).ready(function () {
        const menuBtn = $('a[data-menu-drawer]');
        const closeBtn = $('#btn_close_mobile');

        const announcementBar = $('#shopify-section-announcement-bar');
    
        menuBtn.addClass('force-show flex');
        closeBtn.addClass('force-hide');
    
        menuBtn.on('click', function (e) {
            e.preventDefault();
            menuBtn.removeClass('force-show flex').addClass('force-hide open');
            closeBtn.removeClass('force-hide').addClass('force-show');
    
            announcementBar.fadeOut(150);
        });
    
        closeBtn.on('click', function () {
            closeBtn.removeClass('force-show').addClass('force-hide');
            menuBtn.removeClass('force-hide open').addClass('force-show flex');
    
            announcementBar.fadeIn(150);
        });
    });
});